<div class="tabs">
  @for (item of items; track $index) {
  <button
    class="tab"
    [class.active]="item.key === active()"
    (click)="onTab(item.path, item.key)"
  >
    <span
      class="tab-icon"
      [style.--icon-url]="'url(' + item.icon + ')'"
      aria-hidden="true"
    ></span>
    <span class="label">{{ item.label }}</span>
  </button>
  }
</div>
